/**
 * File to run the Google API's for the food bank
 * archive page.
 */
document.addEventListener("DOMContentLoaded", function () {
  const zipForm = document.getElementById("zipSearch");
  const filterForm = document.getElementById("bankFilter");
  const filters = document.getElementById("foodFilter");
  const filtersTxt = filters.innerHTML;
  const apiKey = "AIzaSyBvL7EJszYV7cXPD035eKjadeBbmC6f9-o";
  const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json`;
  const loading = document.querySelector(".loading-ring");

  filters.addEventListener("click", (e) => {
    document
      .querySelector(".food-bank__header--filter-bar")
      .classList.toggle("is-active");

    if (
      document
        .querySelector(".food-bank__header--filter-bar")
        .classList.contains("is-active")
    ) {
      filters.innerHTML = 'close filters <i class="icon-close"></i>';
    } else {
      filters.innerHTML = filtersTxt;
    }
  });

  zipForm.addEventListener("submit", (e) => {
    e.preventDefault();

    var zipCode = document.getElementById("zipcode").value;

    loading.classList.add("is-active");
    if (!zipCode) return;

    const geocodeUrl = `${apiUrl}?address=${encodeURIComponent(
      zipCode,
    )}&key=${apiKey}`;

    // ---- helpers ----
    function getCountyFromResults(result) {
      if (!result?.address_components) return null;
      const countyComp = result.address_components.find((c) => {
        return c.types.includes("administrative_area_level_2")
          ? c.long_name
          : null;
      });
      return countyComp ? countyComp.long_name : null;
    }

    function isResultInPa(result) {
      if (!result?.address_components) return false;
      return result.address_components.some((c) => {
        c.types.includes("administrative_area_level_1") &&
          (c.long_name === "Pennsylvania" || c.short_name === "PA");
      });
    }

    function pickBestResult(results) {
      const pa = results.find((r) => isResultInPa(r));
      return pa || results[0] || null;
    }

    function reverseGeocodeCounty(lat, lng) {
      const url = `${apiUrl}?latlng=${lat},${lng}&result_type=administrative_area_level_2&key=${apiKey}`;

      return fetch(url)
        .then((r) => r.json())
        .then((rev) => {
          if (rev.status !== "OK" || !rev.results?.length) return null;
          return getCountyFromResults(rev.results[0]);
        })
        .catch(() => null);
    }

    fetch(geocodeUrl)
      .then((response) => response.json())
      .then(async (data) => {
        if (data.status !== "OK" || !data.results?.length) {
          setTimeout(() => {
            loading.classList.remove("is-active");
          }, 500);
          return;
        }

        const best = pickBestResult(data.results);

        if (!best?.geometry?.location) {
          setTimeout(() => {
            loading.classList.remove("is-active");
          }, 500);
          return;
        }

        let lat = best.geometry.location.lat;
        let lng = best.geometry.location.lng;

        // try to get county directly from the forward-geocode result
        let county = getCountyFromResults(best);

        if (!county && lat != null && lng != null) {
          county = await reverseGeocodeCounty(lat, lng);
        }

        const postBody = {
          action: "find_closest_snap_location",
          lat: lat,
          lng: lng,
          ...(county ? { county } : {}),
        };

        fetch(zipCodeAjax.ajaxurl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams(postBody),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data?.data?.post) {
              document
                .querySelector(".food-bank__table")
                .classList.add("is-hidden");
              document.querySelector("#postResult").classList.add("is-active");
              document
                .getElementById("clearFilters")
                .classList.add("is-active");
              document.getElementById("update-message").textContent =
                "Food Bank details has been updated.";
              document.querySelector(".food-bank-container").focus();
              document.querySelector("#postResult").innerHTML = JSON.parse(
                data.data.post,
              );
            }

            setTimeout(() => {
              loading.classList.remove("is-active");
            }, 500);
          })
          .catch((err) => {
            console.error("Error posting to WP AJAX:", err);
            setTimeout(() => {
              loading.classList.remove("is-active");
            }, 500);
          });
      })
      .catch((error) => {
        console.error("Error fetching geolocation data:", error);

        setTimeout(() => {
          loading.classList.remove("is-active");
        }, 500);
      });
  });

  document.getElementById("bankFilter").addEventListener("change", (e) => {
    e.preventDefault();

    const county = document.getElementById("county").value;
    const restUrl = `${window.location.origin}/wp-json/feeding_pa/v1/snap?county=${county}`;

    document.getElementById("countySelected").innerHTML = county + " county";

    loading.classList.add("is-active");

    fetch(restUrl)
      .then((response) => response.json())
      .then((data) => {
        var nData = JSON.parse(data);

        document.getElementById("update-message").textContent =
          "Food Bank details has been updated.";

        document.querySelector(".food-bank-container").focus();

        document.querySelector(".food-bank__header--count").innerHTML =
          nData.count + " Food Banks";

        document.querySelector(".food-bank__table-body").innerHTML =
          nData.posts;

        document.getElementById("clearFilters").classList.add("is-active");

        setTimeout(() => {
          loading.classList.remove("is-active");
        }, 1000);
      })
      .catch((error) => {
        loading.classList.add("is-active");

        console.error("Error fetching posts from REST API:", error);
        document.querySelector(".food-bank__table-body").innerHTML = error;
        document.getElementById("clearFilters").classList.add("is-active");

        setTimeout(() => {
          loading.classList.remove("is-active");
        }, 1000);
      });
  });

  document.getElementById("clearFilters").addEventListener("click", (e) => {
    e.preventDefault();

    const restUrl = `${window.location.origin}/wp-json/feeding_pa/v1/snap`;

    loading.classList.add("is-active");

    document.getElementById("countySelected").innerHTML = "county";

    fetch(restUrl)
      .then((response) => response.json())
      .then((data) => {
        var nData = JSON.parse(data);

        document.querySelector(".food-bank__header--count").innerHTML =
          nData.count + " Food Banks";

        document.querySelector(".food-bank__table-body").innerHTML =
          nData.posts;

        document.getElementById("clearFilters").classList.remove("is-active");
        document
          .querySelector(".food-bank__table")
          .classList.remove("is-hidden");
        document.querySelector("#postResult").classList.remove("is-active");
        document.getElementById("zipcode").value = "";

        setTimeout(() => {
          loading.classList.remove("is-active");
        }, 500);
      })
      .catch((error) => {
        console.error("Error fetching posts from REST API:", error);
        document.querySelector(".food-bank__table-body").innerHTML = error;
        document.getElementById("clearFilters").classList.remove("is-active");

        setTimeout(() => {
          loading.classList.remove("is-active");
        }, 500);
      });
  });
});
